// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6c01bf34b16fe6aa11db","655":"62a422657140b899b4f1"}[chunkId] + ".js";
};